import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "../Pages/Home/HomePage";
import ProductPage from "../Pages/Product/ProductPage";
import Search from "../Pages/Search/Search";
import Login from "../Pages/Auth/Login";
import SignUp from "../Pages/Auth/Signup";
import AboutUs from "../Pages/AdditionalPages/AboutUs";
import TermsOfUse from "../Pages/AdditionalPages/TermsOfUse";
import PrivacyPolicy from "../Pages/AdditionalPages/PrivacyPolicy";
import AffiliateDisclosure from "../Pages/AdditionalPages/AffiliateDisclosure";
import Dashboard from "../Pages/Dashboard/dashboard.jsx";
import ImageSearch from "../Pages/ImageSearch/ImageSearch";
import NewOnSaleProductsPage from "../Pages/NewOnSaleProducts/NewOnSaleProductsPage";
import ViewAllProductsPage from "../Pages/ViewAllProducts/ViewAllProductsPage";
import BrandsPage from "../Pages/Brands/BrandsPage";
import ViewBrandsOnSaleNew from "../Pages/Brands/ViewBrandsOnSaleNew";

const Router = () => {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/search" element={<Search />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/image-search" element={<ImageSearch />} />
        <Route path="/new-arrivals/:brandParam" element={<NewOnSaleProductsPage type="new_arrivals" />} />
        <Route path="/on-sale/:brandParam" element={<NewOnSaleProductsPage type="on_sale" />} />
        <Route path="/view-all/:brandParam" element={<ViewAllProductsPage />} />
        <Route path="/brands" element={<BrandsPage />} />
        <Route path="/brands/new-arrivals" element={<ViewBrandsOnSaleNew />} />
        <Route path="/brands/on-sale" element={<ViewBrandsOnSaleNew />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
